module.exports = __webpack_public_path__ + "static/media/screen.1e85fe63.png";